/// <reference path="common.module.ts" />
/// <reference path="../baseClasses/dataServiceBase.ts" />

module Meevo.Components.Common {

    export class DataService extends Meevo.Components.BaseClasses.DataServiceBase implements Meevo.Components.Common.ICommonDataService {

        getSmartCenter(smartcenter: any): angular.IPromise<any> {
            return this.$http.post(`/${this.appSettings.API_ROOT}/SmartCenter/${smartcenter.id}/Data`,
                {
                    businesstypeid: smartcenter.businessTypeId,
                    homeLocationId: smartcenter.homeLocationId
                }).then((response) => response.data);
        }
        getUserSmartCenters(): angular.IPromise<any> {
            return this.$http.get(`/${this.appSettings.API_ROOT}/Session/SmartCenter/List`)
                .then((response) => response.data);
        }
        getSmartCenterExtendedData(id: Guid): angular.IPromise<any> {
            return this.$http.get(`/${this.appSettings.API_ROOT}/SmartTile/${id}`)
                .then((response) => response.data);
        }
        getSmartTileData(smartTileId: Guid, smartCenterId: Guid): angular.IPromise<any> {
          return this.$http.get(`/${this.appSettings.API_ROOT}/SmartTileData/${smartTileId}/${smartCenterId}`)
            .then((response) => response.data);
        } 

        getReportList(): angular.IPromise<any> {
            let request = {};
            return this.$http.post(`/${this.appSettings.API_ROOT}/Report/List`, request)
                .then((response) => response.data);
        }

        isSessionValid(): angular.IPromise<any> {
            return this.$http.get(`/${this.appSettings.API_ROOT}/IsSessionValid`)
                .then((response) => response.data);
        }

        refreshIdentity(locationId: number): angular.IPromise<any> {
            return this.$http.patch(`/${this.appSettings.API_ROOT}/Session`, { 'locationId': locationId })
                .then((response) => response.data);
        }

        getIdentity(): angular.IPromise<any> {
            return this.getSession()
                .then((response: any) => {
                    let identity = <Meevo.Components.Common.IIdentity>response;
                    return identity;
                }, (err: any) => {
                    console.log("Error form GetIdentity" + err);
                });
        }

        getIdentityFull(): angular.IPromise<any> {

            return this.$q.all([this.getSession(), this.getSystemSettings(), this.getTenantData()])
                .then((response: any) => {
                    let identity = <Meevo.Components.Common.IIdentity>response[0];
                    identity.systemSettings = <Meevo.Components.Common.ISystemSettings>response[1];
                    identity.tenantData = <Meevo.Components.Common.ITenantData>response[2];
                    return identity;
                }).catch((reject) => {
                    console.log("reject:", reject);
                });

        
        }

        login(account: any, config = { withCredentials: true }): angular.IPromise<any> {
            let locationId = { 'locationId': this.identityService.current().locationId };
            let url = `/${this.appSettings.API_ROOT}/auth/credentials?tenantId=${this.identityService.current().tenantId}`;
            if (account.mfaRememberToken) {
                url += `&mfaRememberToken=${account.mfaRememberToken}`;
            };
            return this.$http.post(url, account, config)
                .then((response) => {                    
                    try {
                        let resp = response as any;
                        if (resp.data.responseStatus && resp.data.responseStatus.errorCode === 'MFA_REQUIRED') {
                            return resp.data;
                        }
                        if (resp.data.bearerToken) {
                            this.identityService.setToken(resp.data.bearerToken);
                        }
                    } catch (err) {
                        console.log(`login: no bearer token could be extracted from the response ${err}`);
                    }                    
                    return super.patch(this.appSettings.API_ENDPOINTS.session, locationId)
                });
        }

        logout(): angular.IPromise<any> {
            return this.$http.get(`/${this.appSettings.API_ROOT}/auth/logout`)
                .then((response) => {
                    this.identityService.clearToken();
                    return response.data
                });
        }

        getPostalCodeInfo(request: any): angular.IPromise<any> {
            return this.$http.post(`/${this.appSettings.API_ROOT}/PostalCode`, request)
                .then((response) => response.data);
        }

        public getSmartTileDefinitions(categoryId?: number): angular.IPromise<any> {
            return this.$http.get(`/${this.appSettings.API_ROOT}/SmartTileDefinitions/${categoryId}`)
                .then((response) => response.data);
        }

        private getSession(): angular.IPromise<any> {
            return this.$http.get(`/${this.appSettings.API_ROOT}/Session`)
                .then((response) => response.data).catch((err: any) => { console.log("GetSession"); });
        }

        private getSystemSettings(): angular.IPromise<any> {
            return this.$http.get(`/${this.appSettings.API_ROOT}/System/Settings`)
                .then((response) => response.data).catch((err: any) => { console.log("getSystemSettings"); });
        }

        public getThemeCss(tenantId: number): angular.IPromise<any> {
            let data = {
                css: {},
                colors: {},
            }
            return this.$http.get(`/storagedrv/${tenantId}/styles/meevo.json`)
                .then((response) => response.data)
                .catch((err: any) => {
                    this.$http.post(`/storagedrv/${tenantId}/styles/meevo.json`, data)
                        .then((res) => (res.data))
                        .catch((err: any) =>
                           console.log("could not push default theme"))
                    console.log("No themes applied");
                });
        }

        private getTenantData(): angular.IPromise<any> {
            return this.$http.get(`/${this.appSettings.API_ROOT}/Tenant/Data`)
                .then((response) => response.data);
        }


        constructor(protected appSettings: Meevo.Components.Common.IAppSettings, protected $http: angular.IHttpService, protected $q: angular.IQService, protected identityService: Meevo.Components.Common.IIdentityService, protected $cookies: angular.cookies.ICookiesService) {
            super(appSettings, $http, $q, identityService, $cookies);
        }


        static factory(): Function {
            let svc = (appSettings: Meevo.Components.Common.IAppSettings, $http: angular.IHttpService, $q: angular.IQService, identityService: Meevo.Components.Common.IIdentityService, $cookies: angular.cookies.ICookiesService) => {
                return new DataService(appSettings, $http, $q, identityService, $cookies);
            }

            svc.$inject = ["meevo.AppSettings", "$http", "$q", "meevo.components.common.IdentityService", "$cookies"];
            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.DataService", DataService.factory());

}